export default __webpack_public_path__ + "static/media/ZsuzsiImg.f98bda9a.jpg";